import { Dialog, DialogContent, DialogHeader, DialogTitle } from "src/@/components/ui/dialog";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function ModalMensagensRapidas({
  data,
  pesquisaRespostaRapida,
  dialogRespostasRapidas,
  onClose,
  changePesquisa,
  onSelect,
}) {
  const { t } = useTranslation('chat');
  const [filtroTipo, setFiltroTipo] = useState("todos");

  function validaTipo(type) {
    if (type === "texto") {
      return <span className="text-lg">📝</span>;
    } else if (type === "arquivo") {
      return <span className="text-lg">📁</span>;
    } else if (type === "audio") {
      return <span className="text-lg">🎤</span>;
    }
  }

  const filtrarMensagens = () => {
    if (filtroTipo === "todos") return data;
    return data.filter((item) => item.tipo === filtroTipo);
  };

  return (
    <Dialog open={dialogRespostasRapidas} onOpenChange={onClose}>
      <DialogContent className="max-w-lg min-w-lg">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">{t('input.quickReplies')}</DialogTitle>
        </DialogHeader>
        <div className="p-4">
          <div className="space-y-4">
            <div>
              <Input
                value={pesquisaRespostaRapida}
                onChange={changePesquisa}
                placeholder={t('common:buttons.search')}
                className="w-full"
              />
            </div>
            <div className="flex space-x-2">
              <Button
                variant={filtroTipo === "todos" ? "default" : "outline"}
                onClick={() => setFiltroTipo("todos")}
              >
                {t('quickReplies.all')}
              </Button>
              <Button
                variant={filtroTipo === "texto" ? "default" : "outline"}
                onClick={() => setFiltroTipo("texto")}
              >
                {t('quickReplies.text')}
              </Button>
              <Button
                variant={filtroTipo === "arquivo" ? "default" : "outline"}
                onClick={() => setFiltroTipo("arquivo")}
              >
                {t('quickReplies.file')}
              </Button>
              <Button
                variant={filtroTipo === "audio" ? "default" : "outline"}
                onClick={() => setFiltroTipo("audio")}
              >
                {t('quickReplies.audio')}
              </Button>
            </div>
            <div
              className="space-y-2 overflow-y-auto"
              style={{ height: "400px" }}
            >
              {filtrarMensagens().map((item, index) => (
                <div
                  key={index}
                  className="p-4 bg-gray-100 rounded-lg cursor-pointer hover:bg-gray-200"
                  onClick={() => onSelect(item)}
                >
                  <div className="flex items-start space-x-3">
                    <div>{validaTipo(item.tipo)}</div>
                    <div>
                      <p className="text-sm font-medium">{item.titulo}</p>
                      <p className="text-xs text-gray-600">{item.resposta}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
